import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { A } from 'shared-assets/components/Elements';

const LinkNavWrapper = styled.ul`
  // We need to override .Kareo Ul generic style
  padding: 0 !important;
  margin: 0 auto;

  li {
    display: inline;
  }
  li::after {
    content: ${props => `"${props.separator}"`};
    padding: 0 1rem;
  }
  li:last-child::after {
    content: '';
    padding: 0;
  }
`;

const LinkNav = props => {
  return (
    <LinkNavWrapper separator={props.separator}>
      {props.items &&
        props.items.map((item, index) => {
          // eslint-disable-next-line react/no-array-index-key
          return <li key={index}>{item}</li>;
        })}
    </LinkNavWrapper>
  );
};

LinkNav.propTypes = {
  items: PropTypes.arrayOf(A).isRequired,
  separator: PropTypes.string,
};

LinkNav.defaultProps = {
  separator: '|',
};

export default LinkNav;
